import { createAction } from "redux-actions";
import { PAGE_SIZE_10 } from "../../constants/index";
import { apiGet, apiPost, apiPut } from "../../api/index";
import {
  urlUserSecured,
  urlUserFilterSecured,
  urlUserCoreFilterSecured,
  urlUserCoreCreateSecured,
  urlChangePassCreateSecured,
} from "../../api/urls";

const generateFilterQueryAll = ({ filters }) => {
  let filter = "?";

  if (filters) {
    if (filters.name !== undefined) filter += "name=" + filters.name;
    if (filters.uuid !== undefined) filter += "uuid=" + filters.uuid;
  }
  return filter;
};

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
    if (filters.viveroUuid !== undefined)
      filter += "&viveroUuid=" + filters.viveroUuid;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
    if (filters.email !== undefined) filter += "&email=" + filters.email;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Filter consultEvaluations.
 */
export const filterUser = createAction("FILTER_ALL_USER", (filter) =>
  apiGet(urlUserSecured + generateFilterQueryAll(filter), undefined, false)()
);

/**
 * Filter consultEvaluations.
 */
export const filter = createAction("FILTER_USER", (filter) =>
  apiGet(urlUserFilterSecured + generateFilterQuery(filter), undefined, true)()
);

/**
 * Filter consultEvaluations.
 */
export const filterUserCore = createAction("FILTER_ALL_USER_CORE", (filter) =>
  apiGet(
    urlUserCoreFilterSecured + generateFilterQueryAll(filter),
    undefined,
    false
  )()
);

/**
 * Add user
 */
export const assignUser = createAction("ADD_USER", (obj) =>
  apiPost(urlUserSecured, obj, undefined, true)()
);

/**
 * Create user core
 */
export const createUserCore = createAction("CREATE_USER_CORE", (obj) =>
  apiPost(urlUserCoreCreateSecured, obj, undefined, true)()
);

/**
 * Edit Password user
 */
export const modifyPasswordUser = createAction(
  "UPDATE_PASSWORD",
  (obj, param) => apiPut(urlChangePassCreateSecured, obj, param, true)()
);
